export default __webpack_public_path__ + "static/media/showpanel_SP.883326ae.svg";